import LoginAvatarScreen from './LoginAvatarScreen'
import OAuth from '../components/OAuth'
//import SignUp from '../components/Dashboard/SignUp'
import React from 'react'
import { Link } from 'react-router-dom'
import logo from '../styles/images/logo/trx-logo.png'
import defaultLogo from '../styles/images/logo/baruch-logo.svg'

/**
 * Gets user props from App.js
 * Deals with the login avatar and oauth
 * if user is authorized, allow them to use the home button
 * @param props
 * @returns {*}
 * @constructor
 */
const HeaderScreen = (props) => {

var collegeLogoImage = ""

//images located in src/styles/images/logo/
switch (props.collegeLogoName){
  case "baruch":
    collegeLogoImage = require('../styles/images/logo/baruch-logo-white.svg');
    break;
  case "bentley":
    collegeLogoImage = require('../styles/images/logo/bentley.svg');
    break;
  case "BME":
    collegeLogoImage = require('../styles/images/logo/BME.png');
    break;
  case "hen":
    collegeLogoImage = require('../styles/images/logo/hen.png');
    break;
  case "highpoint":
    collegeLogoImage = require('../styles/images/logo/highpoint-logo.png');
    break;
  case "ntu":
    collegeLogoImage = require('../styles/images/logo/ntu-logo.png');
    break;
  case "nus":
    collegeLogoImage = require('../styles/images/logo/nus-logo.png');
    break;
  case "pitt":
    collegeLogoImage = require('../styles/images/logo/pitt-logo.svg');
    break;
  case "reading":
    collegeLogoImage = require('../styles/images/logo/reading.png');
    break;
  case "rutgers":
    collegeLogoImage = require('../styles/images/logo/rutgers-logo.png');
    break;
  case "udel":
    collegeLogoImage = require('../styles/images/logo/udel-logo.png');
    break;
  case "villanova":
    collegeLogoImage = require('../styles/images/logo/villanova-logo.png');
    break;
  case "GIX":
    collegeLogoImage = require('../styles/images/logo/gix-logo.png');
    break;
}

  console.log('HeaderScreen', props)
  let isDemo = false;
  return (
    <nav className="header">
      <div className='homeButton' style={{"padding": 0, "font-size": '18px', alignItems: 'center'}}>
        <Link to={{pathname: '/Home'}} style={{display: 'flex', flexDirection: "row", alignItems: 'center', gap: '0.5rem', "margin": "1rem", "marginLeft": "0.5rem", height: "100%"}} title="Home" className="homeLink" id="homeLink" onClick={() => {if (props.user) {props.user.setHome()}}}
        >
          {!isDemo &&
          <img style={{"width": "5.5em", "max-height": "8rem", "margin":"0.5rem"}} id="unilogo" src={collegeLogoImage || defaultLogo} />
          }
          {!isDemo &&
          <span className='powerText' style={{"marginTop": "20%", whitespace: "nowrap"}}>Powered By</span>
          }
          <img style={{"width": "10em", "max-height": "15rem", "margin":"0.5rem"}} src={logo} alt="TraderX"/>
        </Link>
      </div>
      <div className="timeHeader">
        {!!props.time &&
          <h1>{props.time.substring(11,19)}</h1>
        }
      </div>
      <div className="logAv">
        <LoginAvatarScreen user={props.user}/>
        <OAuth user={props.user} collegeLogoName={props.collegeLogoName}/>
      </div>
    </nav>
  )
}

export default HeaderScreen



// WEBPACK FOOTER //
// ./src/screens/HeaderScreen.js